import { gql } from '@apollo/client'

import { MENU_CURATION_TASK_LIST_FRAGMENT } from '../../../menu-curation-tasks/graphql/fragments'

const DELETE_PRIORITY_TASK_ALLOCATION_MUTATION = gql`
  mutation deletePriorityTaskAllocationMutation($ids: [ID!]!) {
    deletePriorityTaskAllocation(ids: $ids) {
      ...MenuCurationTaskListFragment
    }
  }
  ${MENU_CURATION_TASK_LIST_FRAGMENT}
`

export default DELETE_PRIORITY_TASK_ALLOCATION_MUTATION
